<div class="adx-dashboard-container">
  <!-- Header -->
  <app-header [isMobileView]="isMobileView" [loggedUser]="loggedUser"></app-header>
  <!-- Main Content -->
  <app-main class="adx-main-content" [isMobileView]="isMobileView" [loggedUser]="loggedUser"></app-main>
</div>
